import React from 'react';
import './styles/App.css';
import { AboutSection } from './sections/AboutSection';
import { IntroSection } from './sections/IntroSection';
import { WorkExperienceSection } from './sections/WorkExperienceSection';
import { SidebarNav } from './sections/sidebars/SidebarNav';
import { SidebarMail } from './sections/sidebars/SidebarMail';
import { Footer } from './sections/Footer';
// import { MainProjects } from './sections/projects/MainProjects';
import { OtherProjects } from './sections/projects/OtherProjects';

const App: React.FC = () => {
  return (
    <div className="App">
      <SidebarNav />
      <div className="Content">
        <IntroSection />
        <AboutSection />
        <WorkExperienceSection />
        {/* <MainProjects /> */}
        <OtherProjects />
        <Footer />
      </div>
      <SidebarMail />
    </div>
  );
};

export default App;
